import { render, staticRenderFns } from "./LenonInput.vue?vue&type=template&id=23533012&scoped=true&"
import script from "./LenonInput.vue?vue&type=script&lang=js&"
export * from "./LenonInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23533012",
  null
  
)

export default component.exports